<template>
  <sui-segment raised>
    <sui-message error v-if="error">
      <h3>{{ $t('strError') }}</h3>
      {{ error }}
    </sui-message>
    <sui-message positive align="center">
      <h3>{{ $t('strThanks') }}</h3>
      {{ $t('strYourData') }}:<br />
      {{ $t('labelTarif') }}: <b>{{ $t(tarif) }}</b><br />
      {{ $t('labelUsername') }}: <b>{{ username }}</b> <br />
      {{ $t('labelPassword') }}: <b>{{ password }}</b> <br />
      <br />
      {{ $t('strDownloads') }}:<br />
      {{ $t('strDownloadVoucher') }}: <a @click="clickDownloadVoucher" style="cursor:pointer"><sui-icon name="download" /> {{ $t('strDownload') }}</a><br />
      {{ $t('strDownloadInvoice') }}: <a @click="clickDownloadInvoice" style="cursor:pointer"><sui-icon name="download" /> {{ $t('strDownload') }}</a>
      <sui-divider></sui-divider>
      <sui-button @click="clickBack" color="red" fluid>{{ $t('btnBackToShop') }}</sui-button>
    </sui-message>
    <sui-dimmer :active="loading">
      <sui-loader>{{ $t('strLoading') }}</sui-loader>
    </sui-dimmer>
  </sui-segment>
</template>

<script>
  import StorageService from '@/services/StorageService.js';
  import ApiService from '@/services/ApiService.js'
  export default {
    name: 'Success',
    components: {
      ApiService,
      StorageService
    },
    metaInfo() {
      return {
        title: this.$t('strThanks'),
        meta: [
          /*{ vmid: 'description', name: 'description', content: 'Der Shop f�r Ihre LAN1 Voucher' }*/
        ]
      }
    },
    data() {
      return {
        error: '',
        loading: true,
        tarif: '-',
        userData: [],
        username: '-',
        password: '-',
        sec2: '',
        sec3: '',
      }
    },
    methods: {
      async clickDownloadVoucher() {
        let response = await ApiService.postDownloadVoucherA4({
          tarif: this.tarif,
          data: [{
            username: this.username,
            password: this.password
          }]
        });

        if (response.status == 200) {
          ApiService.forceFileDownload('voucher.pdf', response.data)
        } else {
          this.$swal(this.$t('error'), this.$t(response.data.errorLabel), 'error')
        }
      },
      async clickDownloadInvoice() {
        let response = await ApiService.postDownloadInvoice({
          ident2: this.sec2,
          ident3: this.sec3
        });

        if (response.status == 200) {
          ApiService.forceFileDownload('invoice.pdf', response.data)
        } else {
          this.$swal(this.$t('error'), this.$t(response.data.errorLabel), 'error')
        }
      },
      clickBack() {
        this.$router.push('/')
      },
      track(transaction_id, product) {
        if (StorageService.isCookieStatisticsAccepted()) {
          this.$gtag.query('event', 'purchase', {
            "transaction_id": transaction_id,
            "value": (product.price / 100),
            "currency": "EUR",
            "tax": 0.19,
            "shipping": 0,
            "items": [
              {
                "id": product.id,
                "name": product.name,
                "category": "Voucher",
                "quantity": 1,
                "price": (product.price / 100),
              }
            ]
          })
        }
      }
    },
    async created() {
      let response = await ApiService.postCheckTransaction({ token: this.$route.params.token })
      this.loading = false;

      if (response.status == 200) {
        this.error = ''
        this.tarif = response.data.tarif
        this.username = response.data.username
        this.password = response.data.password
        this.sec2 = response.data.sec2
        this.sec3 = response.data.sec3
        this.track(response.data.tid, response.data.product)
        this.userData.push({ username: response.data.username, password: response.data.password, name: 'Gast' });
      } else {
        this.$swal(this.$t('error'), this.$t(response.data.errorLabel), 'error')
      }
    },
  }
</script>

<style lang="scss" scoped>
</style>
